module.exports = __webpack_public_path__ + "PatinTPA.png?f70a352926ffbdd23ea6ab0c578453b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PatinTPA.png
// module id = 948
// module chunks = 0